import React from "react";

const Still = () => {
  return (
    <section className="still" aria-labelledby="still-title">
      <div className="container">
        <h2 id="still-title">
          Still <em>not sure</em>?
        </h2>

        <p>
          Take a course on us. About four minutes in, you&apos;ll know whether
          42courses is for you. If you&apos;ve got a team to upskill, our team
          plans page has more on what&apos;s included.
        </p>

        <div className="btn-row">
          <a href="/courses#sample-course" className="btn btn-primary">
            Try a course on us &rarr;
          </a>

          <a href="/team_plans" className="btn btn-secondary">
            For teams &amp; companies
          </a>
        </div>
      </div>
    </section>
  );
};

export default Still;
